import React from 'react';
import { OptimizedImage } from '../common';
import { Heart, Lightbulb, Rocket } from 'lucide-react';


export const CommitmentSection: React.FC = () => {
  const commitments = [
    {
      icon: Heart,
      title: 'Human-Centered AI Solutions',
      description: 'We focus on enhancing human capabilities through collaboration.',
      image: '/images/007.empowering-human-enntered.jpeg',
    },
    {
      icon: Lightbulb,
      title: 'Ethical AI Development',
      description: 'Our commitment to ethics and user trust drives our innovation.',
      image: '/images/008.innovative-approaches.jpeg',
    },
    {
      icon: Rocket,
      title: 'Join Us in Shaping the Future',
      description: 'Together, we can redefine what humans can achieve with AI.',
      image: '/images/009.join-us.jpeg',
    },
  ];

  return (
    <section className="px-4 md:px-16 py-16 md:py-24 lg:py-28 bg-[#F5E6D3]">
      <div className="container mx-auto">
        <div className="flex flex-col items-center">
          <div
            className="mb-12 text-center md:mb-18 lg:mb-20"
          >
            <div className="w-full max-w-4xl mx-auto">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
                <div className="text-center lg:text-left">
                  <p className="mb-3 font-cairo font-semibold text-Color-Neutral-Darker md:mb-4">
                  Commitment
                  </p>
                  <h2 className="mb-5 text-3xl sm:text-4xl md:text-5xl font-bold font-gabarito text-Color-Neutral-Darkest md:mb-6 leading-tight">
                    Our Commitment to Purposeful AI
                  </h2>
                  <p className="text-lg text-Color-Neutral-Dark font-cairo">
                    At MindClave, we prioritize creating AI with a clear purpose.
                    Our systems are designed to solve real problems and deliver
                    meaningful value to users in their everyday lives.
                  </p>
                </div>
                <div className="relative h-[300px] md:h-[400px] rounded-2xl overflow-hidden">
                  <OptimizedImage
                    src="/images/006.mission.jpeg" 
                    alt="Our mission to create purposeful AI" 
                    className="rounded-2xl"
                    sizes="(max-width: 1024px) 100vw, 50vw"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 items-start justify-center gap-y-12 md:grid-cols-3 md:gap-x-8 md:gap-y-16 lg:gap-x-12">
            {commitments.map((commitment, index) => {
              return (
                <div
                  key={index}
                  className="flex w-full flex-col items-center text-center"
                >
                  <div className="mb-6 md:mb-8 w-full aspect-[4/3] rounded-2xl overflow-hidden">
                    <OptimizedImage
                      src={commitment.image} 
                      alt={commitment.title} 
                      className="rounded-2xl"
                      sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
                    />
                  </div>
                  <h3 className="mb-5 text-2xl font-bold font-gabarito text-Color-Neutral-Darkest md:text-3xl md:leading-tight lg:text-4xl">
                    {commitment.title}
                  </h3>
                  <p className="text-Color-Neutral-Dark font-cairo">
                    {commitment.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};